// Minimal VAST 2.0 / 3.0 / 4.0 Linear-Inline parser.
// Supports: MediaFile (video URL), ClickThrough, Impression pixels, Duration.
// Falls back to null on parse errors or Wrappers (no ad exchange chain).

export async function fetchVast(url) {
  if (!url) return null;
  try {
    const res = await fetch(url, { method: 'GET' });
    if (!res.ok) return null;
    const xml = await res.text();
    return parseVast(xml);
  } catch {
    return null;
  }
}

export function parseVast(xml) {
  let doc;
  try {
    doc = new DOMParser().parseFromString(xml, 'application/xml');
  } catch { return null; }
  if (!doc || doc.getElementsByTagName('parsererror').length) return null;

  const ad = doc.querySelector('Ad');
  if (!ad) return null;

  const linear = ad.querySelector('InLine Linear') || ad.querySelector('Wrapper Linear') || ad.querySelector('Linear');
  if (!linear) return null;

  // Pick a progressive mp4 MediaFile (highest bitrate under 2000, else first)
  const mediaFiles = Array.from(linear.querySelectorAll('MediaFiles MediaFile'));
  const progressive = mediaFiles.filter(m => (m.getAttribute('delivery') || 'progressive') === 'progressive');
  const mp4s = progressive.filter(m => (m.getAttribute('type') || '').toLowerCase().includes('mp4'));
  const pick = mp4s[0] || progressive[0] || mediaFiles[0];
  const mediaUrl = pick ? (pick.textContent || '').trim() : '';
  if (!mediaUrl) return null;

  const clickThrough = (linear.querySelector('VideoClicks ClickThrough')?.textContent || '').trim();
  const clickTracking = Array.from(linear.querySelectorAll('VideoClicks ClickTracking'))
    .map(n => (n.textContent || '').trim()).filter(Boolean);
  const impressions = Array.from(ad.querySelectorAll('Impression'))
    .map(n => (n.textContent || '').trim()).filter(Boolean);
  const durationTxt = (linear.querySelector('Duration')?.textContent || '').trim();
  const duration = parseVastDuration(durationTxt);

  const title = (ad.querySelector('AdTitle')?.textContent || '').trim();
  return { mediaUrl, clickThrough, clickTracking, impressions, duration, title };
}

export function parseVastDuration(s) {
  if (!s) return null;
  const parts = s.split(':').map(Number);
  if (parts.some(Number.isNaN)) return null;
  let sec = 0;
  if (parts.length === 3) sec = parts[0] * 3600 + parts[1] * 60 + parts[2];
  else if (parts.length === 2) sec = parts[0] * 60 + parts[1];
  else sec = parts[0];
  return Math.round(sec);
}

// Fire a tracking pixel (VAST Impression or ClickTracking URL).
export function firePixel(url) {
  if (!url) return;
  try {
    const img = new Image();
    img.referrerPolicy = 'no-referrer-when-downgrade';
    img.src = url;
  } catch {}
}
